import { library } from '@fortawesome/fontawesome-svg-core'

import {faUserSecret, faSlidersH, faBars} from '@fortawesome/free-solid-svg-icons'


library.add(faUserSecret, faSlidersH, faBars)
